import React, { FC } from 'react'
import { ColorNames, LandingNames } from 'Pages/landings/newLandings/common/constants'
import { useAdriverPixel } from 'Pages/landings/newLandings/common/hooks'
import bannerMobileWebp from './bannerMobile.webp'
import bannerMobileJpg from './bannerMobile.jpg'
import banner from './banner.jpg'
import { BannerStyled, TextBanner, TextTitle } from './styled'

export const BannerComponent: FC = () => {
	const containerRef = useAdriverPixel(LandingNames.SELF_EMPLOYED)
	return (
		<div ref={containerRef}>
			<BannerStyled
				bannerMobileWebp={bannerMobileWebp}
				bannerMobileJpg={bannerMobileJpg}
				srcBanner={banner}
				subTitle={
					<TextTitle>
						И получите после подключения бесплатного сервиса «Своё дело» доступ&nbsp;к&nbsp;каталогу
						полезных инструментов, созданию онлайн-чеков и&nbsp;оплате налога
					</TextTitle>
				}
				buttonScrollTo="form"
				type={ColorNames.PRIMARY}
			>
				<TextBanner>
					Станьте самозанятым
					<br />
					со Сбером
				</TextBanner>
			</BannerStyled>
		</div>
	)
}
